import React, { useState } from 'react';
import { Box, Button, CircularProgress, Grid, Typography } from '@material-ui/core';
import MbTextField from '../_components/MbTextField';
import _ from 'lodash';
import useIugu from '../_helpers/iugu';
import config from '../_helpers/config';

export default function CreditCardDataForm({ 
    disclaimer, 
    formData, 
    loading, 
    primaryButtonAction, 
    primaryButtonLabel, 
    primaryButtonId,
    secondaryButtonAction,
    secondaryButtonLabel, 
    setFormData,
    setLoading
}) {
    const iugu = useIugu(config.IUGU_ACCOUNT_ID, config.IUGU_TEST_MODE);
    const [errors, setErrors] = useState({});

    const handlePropertyChange = (e) => {
        // Set the changed property
        setFormData(currentFormData => {
            let newFormData = { ...currentFormData };
            _.set(newFormData, e.target.name, e.target.value)
            return newFormData;
        });

        // Clear the error of the changed property
        setErrors(currentErrors => ({ ...currentErrors, [e.target.name]: null }))
    }

    async function validateFormData(e) {
        e.preventDefault();

        const errors = {};
        setErrors({});
        setLoading(true);

        // Validate credit card input
        const paymentTokenResponse = await iugu.createPaymentToken(e.target);

        if (_.has(paymentTokenResponse, 'errors.number')) {
            _.set(errors, 'creditCard.number', 'Insira um número válido.');
        }
        if (_.has(paymentTokenResponse, 'errors.expiration')) {
            _.set(errors, 'creditCard.expiration', 'Data de expiração inválida.');
        }
        if (_.has(paymentTokenResponse, 'errors.verification_value')) {
            _.set(errors, 'creditCard.cvv', 'Insira um número válido.');
        }
        if (_.has(paymentTokenResponse, 'errors.first_name') || _.has(paymentTokenResponse, 'errors.last_name')) {
            _.set(errors, 'creditCard.name', 'Nome inválido.');
        }

        // Try to get the creditCardToken parameter
        const creditCardToken = _.get(paymentTokenResponse, 'id', '');

        if (_.isEmpty(errors)) {
            handlePropertyChange({ target: { name: 'creditCardToken', value: creditCardToken } });
            primaryButtonAction(creditCardToken);
        } else {
            setErrors(errors);
            setLoading(false);
        }
    }

    return (
        <form id="credit_card_data_form" onSubmit={validateFormData}>
            <Box>
                <img src={require(`../_assets/img/credit_card_flags.png`).default} width="230" alt="Credit card flags" />

                <Grid container direction="row" spacing={2}>
                    <Grid item xs={12} >
                        <MbTextField
                            error={_.get(errors, 'creditCard.number', null)}
                            label="Número do cartão:"
                            name="creditCard.number"
                            onChange={handlePropertyChange}
                            value={formData.creditCard.number || ''}
                            mask={_.get(formData, 'creditCard.number[0]', '') === '3' ? "9999 999999 99999" : "9999 9999 9999 9999"}
                            inputProps={{
                                'data-iugu': 'number'
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} >
                        <MbTextField
                            error={_.get(errors, 'creditCard.name', null)}
                            label="Nome no cartão:"
                            name="creditCard.name"
                            onChange={handlePropertyChange}
                            value={formData.creditCard.name || ''}
                            inputProps={{
                                'data-iugu': 'full_name'
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} >
                        <MbTextField
                            error={_.get(errors, 'creditCard.cvv', null)}
                            label="Código de segurança:"
                            name="creditCard.cvv"
                            onChange={handlePropertyChange}
                            value={formData.creditCard.cvv || ''}
                            mask={'9999'}
                            inputProps={{
                                'data-iugu': 'verification_value'
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} >
                        <MbTextField
                            error={_.get(errors, 'creditCard.expiration', null)}
                            label="Data de expiração:"
                            name="creditCard.expiration"
                            onChange={handlePropertyChange}
                            value={formData.creditCard.expiration || ''}
                            mask={'99/99'}
                            inputProps={{
                                'data-iugu': 'expiration',
                                placeholder: 'MM/AA'
                            }}
                        />
                    </Grid>
                </Grid>

                <Box mt={6}>
                    <Typography variant="body2" align="justify">
                        {disclaimer}
                    </Typography>
                </Box>
            </Box>

            {loading ? (
                <Box alignItems="center" display="flex" justifyContent="center" my={8}>
                    <CircularProgress color="primary" />
                </Box>
            ) : (
                <Box alignItems="center" display="flex" justifyContent="center" my={8}>
                    {!_.isEmpty(secondaryButtonLabel) &&
                        <Button color="primary" style={{ marginRight: 50 }} onClick={secondaryButtonAction}>
                            {secondaryButtonLabel}
                        </Button>
                    }

                    <Button id={primaryButtonId} variant="contained" color="primary" disableElevation type="submit">
                        {primaryButtonLabel}
                    </Button>
                </Box>
            )}
        </form>
    );
}